import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useAddColumnToNormalizationMutation = ({ onSuccess, submitService }) => {
	const dispatch = useDispatch();

	return useMutation(submitService, {
		onMutate() {
			dispatch(uiActions.showSpinnerOverlay());
		},
		onSuccess({ id }) {
			dispatch(
				uiActions.showSuccessNotification({
					title: "Column has been successfully added",
				}),
			);
			onSuccess?.(id);
		},
		onError(error: ErrorResponse) {
			dispatch(
				uiActions.showErrorNotification({
					title: getErrorMessage(error),
				}),
			);
		},
		onSettled() {
			dispatch(uiActions.hideSpinnerOverlay());
		},
	});
};

export default useAddColumnToNormalizationMutation;
